import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Homepage from '../HomePage';
import AboutPage from '../AboutPage';
import CasePage from '../CasePage';
import CaseSinglePage from '../CaseSinglePage';
import EventPage from '../EventPage';
import EventPageSingle from '../EventPageSingle';
import DonatePage from '../DonatePage';
import VolunteerPage from '../volunteerPage';
import BlogPage from '../BlogPage';
import BlogPageLeft from '../BlogPageLeft';
import BlogPageFullwidth from '../BlogPageFullwidth';
import BlogDetails from '../BlogDetails';
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide';
import BlogDetailsFull from '../BlogDetailsFull';
import ErrorPage from '../ErrorPage';
import ContactPage from '../ContactPage';
import SignUpPage from '../SignUpPage';
import LogInPage from '../LoginPage';
import ForgotPassword from '../ForgotPassword';
import GalleryPage from '../GalleryPage';
import PublicationListPage from '../PublicationPage';
import DashboardPage from '../DashboardPage';
import DashboardUsersPage from '../DashboardPage/UsersPage';
import DashboardGalleryPage from '../DashboardPage/GalleryPage';
import DashboardEventsPage from '../DashboardPage/EventsPage';
import DashboardVolunteersPage from '../DashboardPage/VolunteersPage';
import DashboardDonationsPage from '../DashboardPage/DonationsPage';
import DashboardReportsPage from '../DashboardPage/ReportsPage';
import DashboardBlogPostsPage from '../DashboardPage/BlogPostsPage';
import DashboardGalleryPhotoPage from '../DashboardPage/GalleryPage/view';
import DashboardPublishGalleryPhotoPage from '../DashboardPage/GalleryPage/create';
import DashboardEditGalleryPhotoPage from '../DashboardPage/GalleryPage/edit';
import DashboardPublishEventPage from '../DashboardPage/EventsPage/create';
import DashboardEventPage from '../DashboardPage/EventsPage/view';
import DashboardEditEventPage from '../DashboardPage/EventsPage/edit';
import DashboardRegisterDonationPage from '../DashboardPage/DonationsPage/create';
import DashboardDonationPage from '../DashboardPage/DonationsPage/view';
import DashboardEditDonationPage from '../DashboardPage/DonationsPage/edit';
import DashboardPublishReportPage from '../DashboardPage/ReportsPage/create';
import DashboardEditReportPage from '../DashboardPage/ReportsPage/edit';
import DashboardRegisterVolunteerPage from '../DashboardPage/VolunteersPage/create';
import DashboardVolunteerPage from '../DashboardPage/VolunteersPage/view';
import DashboardEditVolunteerPage from '../DashboardPage/VolunteersPage/edit';
import DashboardPublishBlogPostPage from '../DashboardPage/BlogPostsPage/create';
import DashboardBlogPostPage from '../DashboardPage/BlogPostsPage/view';
import DashboardEditBlogPostPage from '../DashboardPage/BlogPostsPage/edit';
import PrivateRoute from './PrivateRoute';
import SponsoredChildrenPage from '../SponsoredChildrenPage';
import DashboardSponsoredKidsPage from '../DashboardPage/SponsoredKidsPage';
import DashboardSponsoredKidPage from '../DashboardPage/SponsoredKidsPage/view';
import DashboardEditSponsoredKidPage from '../DashboardPage/SponsoredKidsPage/edit';
import DashboardRegisterSponsoredKidPage from '../DashboardPage/SponsoredKidsPage/create';
import DashboardSponsoredKidsDonationsPage from '../DashboardPage/SponsoredKidsDonationsPage';
import DashboardSponsoredKidDonationPage from '../DashboardPage/SponsoredKidsDonationsPage/view';
import DashboardEditSponsoredKidDonationPage from '../DashboardPage/SponsoredKidsDonationsPage/edit';
import DashboardRegisterSponsoredKidDonationPage from '../DashboardPage/SponsoredKidsDonationsPage/create';

const AllRoutes = () => {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/about" component={AboutPage} />
          <Route path="/case" component={CasePage} />
          <Route path="/case-single/:causeId" component={CaseSinglePage} />
          <Route path="/events/:slugId" component={EventPageSingle} />
          <Route path="/events" component={EventPage} />
          <Route path="/donate" component={DonatePage} />
          <Route path="/volunteer" component={VolunteerPage} />
          <Route path="/blog" component={BlogPage} />
          <Route path="/blog-left" component={BlogPageLeft} />
          <Route path="/blog-fullwidth" component={BlogPageFullwidth} />
          <Route path="/blog-details/:slugId" component={BlogDetails} />
          <Route path="/blog-details-left" component={BlogDetailsLeftSiide} />
          <Route path="/blog-details-fullwidth" component={BlogDetailsFull} />
          <Route path="/404" component={ErrorPage} />
          <Route path="/contact" component={ContactPage} />
          <Route path="/signup" component={SignUpPage} />
          <Route path="/login" component={LogInPage} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route path="/gallery" component={GalleryPage} />
          <Route path="/publications" component={PublicationListPage} />
          <Route path="/sponsored-children" component={SponsoredChildrenPage} />
          {/* PROTECTED ROUTES */}
          <PrivateRoute exact path="/dashboard" component={DashboardPage} />
          <PrivateRoute
            path="/dashboard/users"
            component={DashboardUsersPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/gallery-photos"
            component={DashboardGalleryPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/gallery-photos/new"
            component={DashboardPublishGalleryPhotoPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/gallery-photos/:photoId"
            component={DashboardGalleryPhotoPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/gallery-photos/:photoId/edit"
            component={DashboardEditGalleryPhotoPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/events"
            component={DashboardEventsPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/events/new"
            component={DashboardPublishEventPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/events/:eventId"
            component={DashboardEventPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/events/:eventId/edit"
            component={DashboardEditEventPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/volunteers"
            component={DashboardVolunteersPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/volunteers/new"
            component={DashboardRegisterVolunteerPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/volunteers/:volunteerId"
            component={DashboardVolunteerPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/volunteers/:volunteerId/edit"
            component={DashboardEditVolunteerPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/general-donations"
            component={DashboardDonationsPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/general-donations/new"
            component={DashboardRegisterDonationPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/general-donations/:donationId"
            component={DashboardDonationPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/general-donations/:donationId/edit"
            component={DashboardEditDonationPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/reports"
            component={DashboardReportsPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/reports/new"
            component={DashboardPublishReportPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/reports/:reportId/edit"
            component={DashboardEditReportPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/blog-posts"
            component={DashboardBlogPostsPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/blog-posts/new"
            component={DashboardPublishBlogPostPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/blog-posts/:postId"
            component={DashboardBlogPostPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/blog-posts/:postId/edit"
            component={DashboardEditBlogPostPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/sponsored-kids"
            component={DashboardSponsoredKidsPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/sponsored-kids/new"
            component={DashboardRegisterSponsoredKidPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/sponsored-kids/:kidId"
            component={DashboardSponsoredKidPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/sponsored-kids/:kidId/edit"
            component={DashboardEditSponsoredKidPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/donations-sponsored-kids/new"
            component={DashboardRegisterSponsoredKidDonationPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/donations-sponsored-kids"
            component={DashboardSponsoredKidsDonationsPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/donations-sponsored-kids/:donationId"
            component={DashboardSponsoredKidDonationPage}
          />
          <PrivateRoute
            exact
            path="/dashboard/donations-sponsored-kids/:donationId/edit"
            component={DashboardEditSponsoredKidDonationPage}
          />
          <Route exact path="/" component={Homepage} />
        </Switch>
      </Router>
    </div>
  );
};

export default AllRoutes;
